var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"program_wrapper"},[_c('h2',[_vm._v("Пресс-центр")]),_c('div',{staticClass:"ckEditor-html",domProps:{"innerHTML":_vm._s(_vm.GET_CURRENT_FORUM.program_text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }